// 数据口径
export enum Timeline {
  play = 1,
  report = 2,
  active = 3,
}
